import css from 'styled-jsx/css';

const ImageGalleryHeadlineMobileStyles = css`
  .youtube-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .youtube-wrapper {
    width: 100%;
    max-width: 100%;
    height: 100%;
  }

  .headline-wrapper {
    text-align: center;
    outline: none;
    position: relative;

    .image-slider {
      position: relative;
      touch-action: pan-y;
      user-select: none;
      -webkit-user-drag: none;
    }

    .image-wrapper {
      display: flex;
      align-items: center;
      width: 100vw;
      height: 100vw;
      &.out-of-stock {
        width: 100%;
        height: 84px;
      }
    }

    .image-headline {
      flex-shrink: 0;
      display: flex;
      width: 100%;
      height: 100%;
      justify-content: center;

      &.zoom {
        transform-origin: 0 0;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: auto;
        max-width: none;
      }
    }

    .image-headline :global(img) {
      width: 100%;
      height: 100%;
    }

    .image-zoom-container {
      visibility: hidden;
      touch-action: none;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;

      &.visible {
        visibility: visible;
      }
    }

    .image-zoom-container-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
    }

    /* Video container styles - moved from inline */
    .video-container {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .video-smart-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: transparent;
      z-index: 10;
      touch-action: none;
    }
  }
`;

const ImageGalleryMobileVideoStyles = css`
  .video-headline {
    position: relative;
    flex-shrink: 0;
    width: 100vw;
    height: 100%;

    span.video-icon {
      position: absolute;
      width: 63px;
      height: 63px;
      border-radius: 100%;
      border: 3px solid white;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: black;
    }

    .video-thumbnail {
      height: 100%;
      width: 100%;
    }
  }

  .video-frame {
    width: 100%;
    height: 100%;
  }
`;

export { ImageGalleryHeadlineMobileStyles, ImageGalleryMobileVideoStyles };
